import { Select, MenuItem } from "@mui/material";

import { industries } from "../../config/profileIndustries";
import { useLocalizedTranslation } from "../../hooks/useLocalizedTranslation";

const IndustrySelect = ({
  name = "industry",
  placeholder = "",
  value = "",
  onChange = () => {},
  language = null,
}) => {
  const { t: translation } = useLocalizedTranslation(
    language,
    "components/industrySelect"
  );

  return (
    <Select
      id={name}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">{translation("emptyMenuItem")}</MenuItem>

      {industries.map((industry) => (
        <MenuItem key={industry} value={industry}>
          {translation(industry)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default IndustrySelect;
